// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithIconUrlPosts_button__eyCzP","buttonText":"ButtonWithIconUrlPosts_buttonText__dacpN"};